"use client";
import { jsx } from "react/jsx-runtime";
import { useEnvironment } from "../../hooks/useEnvironment.js";
import { useTracking } from "../../hooks/useTracking.js";
import { useMantineTheme, createPolymorphicComponent } from "@mantine/core";
import { forwardRef } from "react";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./Fallback.js";
const sharedHandler = (Component) => forwardRef((props, ref) => {
  const { test, scale = 1, ...rest } = props;
  const theme = useMantineTheme();
  const tracker = useTracking();
  const { variables } = useEnvironment();
  const errorHandler = (error) => {
    var _a;
    if (error && variables.env === "prod") {
      (_a = tracker == null ? void 0 : tracker.monitor) == null ? void 0 : _a.exception({
        message: error.message,
        severityLevel: 3,
        properties: { ...error }
      });
    }
  };
  const FallBack = variables.env === "prod" ? /* @__PURE__ */ jsx("div", {}) : FallbackComponent;
  const resolvedScale = { "--mantine-scale": scale * theme.scale };
  const resolvedTesting = { "data-test": test || rest["data-test"] };
  const resolvedProps = {
    ...rest,
    ...resolvedTesting,
    scale,
    style: { ...resolvedScale, ...rest.style }
  };
  const Comp = /* @__PURE__ */ jsx(Component, { ref, ...resolvedProps });
  return createPolymorphicComponent(
    /* @__PURE__ */ jsx(ErrorBoundary, { FallbackComponent: FallBack, onError: errorHandler, children: Comp })
  );
});
export {
  sharedHandler
};
